import { cn } from "@/lib/utils";

/** Inline segment triggers inside the filter chip (shared with SearchableSegment / DateRangeSegment). */
export const filterSegmentTriggerClassName = cn(
  "inline-flex h-full min-h-0 cursor-pointer items-center justify-start gap-1 overflow-hidden rounded-none px-1.5 py-0 text-[13px] font-medium leading-none transition-opacity hover:opacity-80",
);
